import React, { useState } from "react";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";

/**
 * Inline image preview; clicking opens a near-fullscreen dialog with the same asset.
 */
const UIExpandableImage = ({
  src,
  alt,
  thumbnailImgSx,
  frameSx,
  expandAriaLabel,
  closeAriaLabel,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box sx={{ ...frameSx }}>
        <Box
          component="button"
          type="button"
          onClick={() => setOpen(true)}
          sx={{
            cursor: "zoom-in",
            border: "none",
            padding: 0,
            margin: 0,
            width: "100%",
            display: "block",
            background: "transparent",
            borderRadius: "inherit",
          }}
          aria-label={expandAriaLabel}
        >
          <Box
            component="img"
            src={src}
            alt={alt}
            sx={{
              display: "block",
              width: "100%",
              ...thumbnailImgSx,
            }}
          />
        </Box>
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={false}
        scroll="body"
        PaperProps={{
          sx: {
            maxWidth: "min(96vw, 1400px)",
            maxHeight: "92vh",
            m: 2,
            bgcolor: "rgba(15, 23, 42, 0.94)",
            boxShadow: 24,
          },
        }}
      >
        <DialogContent
          sx={{
            p: 1.5,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            type="button"
            onClick={() => setOpen(false)}
            aria-label={closeAriaLabel}
            sx={{
              position: "absolute",
              right: 10,
              top: 10,
              zIndex: 1,
              color: "#fff",
              bgcolor: "rgba(255,255,255,0.14)",
              "&:hover": { bgcolor: "rgba(255,255,255,0.24)" },
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
          <Box
            component="img"
            src={src}
            alt={alt}
            sx={{
              maxWidth: "100%",
              maxHeight: "calc(92vh - 32px)",
              objectFit: "contain",
              display: "block",
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

UIExpandableImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  thumbnailImgSx: PropTypes.object,
  frameSx: PropTypes.object,
  expandAriaLabel: PropTypes.string.isRequired,
  closeAriaLabel: PropTypes.string.isRequired,
};

UIExpandableImage.defaultProps = {
  alt: "",
  thumbnailImgSx: {},
  frameSx: {},
};

export default UIExpandableImage;
